enum Pronouns {
    She = 'pronouns_she',
    He = 'pronouns_he',
    They = 'pronouns_they',
    Other = 'pronouns_other'
}

enum Title {
    Prof = 'title_prof',
    Dr = 'title_dr',
    ProfDr = 'title_prof_dr',
    Mag = 'title_mag'
}

enum Organisation {
    Association = 'association',
    Company = 'company',
    Other = 'other'
}

type ResultContactPerson = {
    firstname: string;
    lastname: string;
    email: string;
    company: string;
    title?: Title;
    pronouns?: Pronouns;
};

export { Pronouns, Title, Organisation };
export type { ResultContactPerson };
